import { render, staticRenderFns } from "./BusDocuments.vue?vue&type=template&id=0c46d6e9&scoped=true"
import script from "./BusDocuments.vue?vue&type=script&lang=js"
export * from "./BusDocuments.vue?vue&type=script&lang=js"
import style0 from "./BusDocuments.vue?vue&type=style&index=0&id=0c46d6e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c46d6e9",
  null
  
)

export default component.exports